import { render, staticRenderFns } from "./form24Q.vue?vue&type=template&id=864de79e&scoped=true&lang=html"
import script from "./form24Q.vue?vue&type=script&lang=js"
export * from "./form24Q.vue?vue&type=script&lang=js"
import style0 from "./form24Q.vue?vue&type=style&index=0&id=864de79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864de79e",
  null
  
)

export default component.exports